module.exports = __webpack_public_path__ + "img/logo_hum_do.ccc5e81b.png";